// @flow
import * as actionTypes from '../../actionTypes/datasetTypes'

const {
  SET_SHOWING_DATASET,
  UPDATE_SHOWING_DATA,
  RESET_SHOWING_DATASET,
  REQUEST_RELATED,
  UPDATE_ROOT_DATASET
} = actionTypes

export default function datasetReducer(state: Object = {}, action: Object): Object {
  switch (action.type) {
    case UPDATE_SHOWING_DATA:
      return {
        ...state,
        showingData: action.showingData
      }
    case UPDATE_ROOT_DATASET:
      return {
        ...state,
        rootData: action.rootData
      }
    case SET_SHOWING_DATASET:
      return {
        ...state,
        selected: action.selected,
        showingData: action.data,
        isFetching: false,
        hasRelated: true
      }
    case RESET_SHOWING_DATASET:
      return {
        ...state,
        showingData: action.data,
        selected: null,
        hasRelated: false
      }
    case REQUEST_RELATED:
      return {
        ...state,
        hasError: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/shared/reducers/dataset/dataset.js